import React, { useState } from "react";

import "./key-results-accordion.scss";
import { ReactSVG } from "react-svg";
import { CodeSquare } from "lucide-react";
import StandardButton from "../../../../shared/formComponents/StandardButton/StandardButton";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";
import { SmallNormalText } from "../../../../../utils/typographyUtils";
import { ConditionalRender } from "../../../../shared/ConditionalRender/ConditionalRender";
import StandardInput from "../../../../shared/formComponents/StandardInput/StandardInput";
export const KeyResultsAccordionItem = ({
  itemData,
  isViewMode,
  isLastItem,
  number,
  showConfirmationButtons,
  setShowConfirmationButtons,
  editMode,
  disableOperations,
  setShowDeleteKeyResultPopup,
  buttonDisabled,
  handleUpdateBusinessPlanKeyResult,
  handleDeleteBusinessPlanKeyResult,
  showActions,
  isPlanPublished,
}) => {
  const [originalKeyResult, setOriginalKeyResult] = useState(
    itemData.keyResult
  );
  const [originalOutcome, setOriginalOutcome] = useState(itemData.outcome);

  const handleUpdateValue = (value) => {
    setOriginalKeyResult(value);
  };

  const handleShowButtons = (type) => {
    const color =
      showConfirmationButtons.type === "delete"
        ? "btn-border-danger"
        : "btn-outline-brand-blue-new";
    const text =
      showConfirmationButtons.type === "delete" ? "Delete" : "Update";

    const cancelButton = (
      <StandardButton
        disabled={true}
        color="btn-border"
        className="py-1"
        text="Cancel"
        onClick={() => {}}
      />
    );
    if (
      showConfirmationButtons.id === itemData.keyResultId &&
      showConfirmationButtons.show
    ) {
      return (
        <div className="d-flex align-items-center">
          {cancelButton}
          <StandardButton
            disabled={true}
            color={color}
            className="mx-2 py-1"
            text={text}
            onClick={() => {
              if (showConfirmationButtons.type === "update") {
                handleUpdateBusinessPlanKeyResult(
                  originalKeyResult,
                  itemData.keyResultId
                );
              } else {
                handleDeleteBusinessPlanKeyResult(itemData.keyResultId);
              }
            }}
            darkLoader={true}
            isLoading={buttonDisabled}
          />
        </div>
      );
    }
    if (!showActions) {
      return null;
    }
    if (isLastItem) {
      return (
        <StandardTooltip
          tooltTipContent={"Can't delete — at least one key result required"}
        >
          <img
            className={`key-result-delete-icon me-3 cursor-disabled`}
            src="/assets/images/deleteIcon-disabled.svg"
            height={18}
            width={18}
          />
        </StandardTooltip>
      );
    }

    return (
      <div className="d-flex align-items-center">
        <img
          className={`key-result-delete-icon me-3 cursor-disabled`}
          src="/assets/images/deleteIcon.svg"
          height={18}
          width={18}
        />
      </div>
    );
  };
  const handleOutcomeInputColor = () => {
    let inputColor = "zero-percent-input-color";
    if (originalOutcome >= 0) {
      if (originalOutcome > 0 && originalOutcome < 31) {
        inputColor = "one-to-thirty-percent-input-color";
      } else if (originalOutcome >= 31 && originalOutcome < 81) {
        inputColor = "thirty-one-to-eighty-percent-input-color";
      } else if (originalOutcome >= 81) {
        inputColor = "eighty-one-to-hundred-percent-input-color";
      }
    }
    return inputColor;
  };

  return (
    <div id="key-results-item">
      <div className="row px-3 py-2">
        <div className="col-12 key-result-item-main">
          <div className="row">
            <div className={`${isPlanPublished ? "col-6" : "col-7"} d-flex`}>
              <div className="me-4 d-flex align-items-center">
                <SmallNormalText classNames={"me-2"}>{number}</SmallNormalText>
              </div>
              <div
                className={`d-flex align-items-center ${
                  disableOperations ? "" : "flex-grow-1"
                }`}
                onClick={() => {}}
              >
                <SmallNormalText>{itemData.keyResult}</SmallNormalText>
              </div>
            </div>
            <div className={`col-4 d-flex`}>
              <div className={`d-flex align-items-center`}>
                <SmallNormalText onClick={() => {}}>
                  {itemData.target}
                </SmallNormalText>
              </div>
            </div>
            <ConditionalRender condition={isPlanPublished}>
              <div
                className={`col-1 d-flex align-items-center position-relative published-plan-outcome ${handleOutcomeInputColor()}`}
              >
                <StandardInput
                  variant="bordered"
                  type={"number"}
                  className={""}
                  disabled={disableOperations}
                  inputMargin="ms-0"
                  value={itemData.outcome}
                  onChange={(e) => {}}
                />
                <SmallNormalText classNames={"position-absolute outcome-text"}>
                  %
                </SmallNormalText>
              </div>
            </ConditionalRender>
            <div className="col-1 d-flex align-items-center justify-content-center">
              {handleShowButtons()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
